module.exports = __webpack_public_path__ + "media/images/lb/717-921ea23f34cd6844e3bc6126a72462a9.svg";